<div class="stacked-bar-chart-container">
  @if (barChartData()) {
    <canvas
      baseChart
      [type]="barChartType()"
      [data]="barChartData() || undefined"
      [options]="barChartOptions()"
      [plugins]="barChartPlugins()"
    ></canvas>
  } @else {
    <div class="no-data">No data available</div>
  }
</div>
